import React, { useState, useEffect } from "react";
import { FaStar } from "react-icons/fa";

// ========================
// CallToAction Component
// ========================
const CallToAction = () => { 
  return (
    <section className="py-12 bg-white sm:py-16 lg:py-20 xl:py-24">
      <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
        <div className="max-w-2xl mx-auto text-center">
          <p className="inline-block px-4 py-1 text-base font-semibold text-white bg-blue-600 rounded-full">
              Enjoy 100 free credits when you sign up
          </p>
          <h2 className="mt-6 text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl lg:mt-8 lg:text-5xl">
            Start building high-performing personalized B2B campaigns
          </h2>

          {/* <div className="flex flex-col items-stretch mt-8 space-y-4 sm:flex-row sm:items-center sm:justify-center sm:space-y-0 sm:space-x-4 sm:mt-10">
            <a
              href="#"
              className="inline-flex items-center justify-center px-6 py-3 text-base font-medium text-white transition-all duration-200 bg-blue-600 border border-transparent rounded-full shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-700"
              role="button"
            >
              Build Personalized Outreach
            </a>

            <a
  href="https://www.youtube.com/embed/ydA_ziiaHl8?si=PYLphKtcLC23taxD"
  className="inline-flex items-center justify-center px-6 py-3 text-base font-semibold text-white bg-blue-600 rounded-full hover:bg-blue-700 transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
  role="button"
>
  <svg
    className="w-6 h-6 mr-3 -ml-1 text-white"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
  Watch How It Works
</a>

          </div> */}
        </div>

        {/* <div className="max-w-2xl mx-auto mt-16 text-center lg:mt-20">
          <p className="text-sm font-normal text-gray-600">
            Join over 200+ tech companies already using PreciseDraft
          </p>

          <div className="inline-grid grid-cols-2 gap-8 mt-8 sm:gap-x-12 sm:gap-y-10 sm:grid-cols-4 sm:mt-12">
            <img
              className="object-contain h-8 max-w-full sm:h-10 w-44"
              src="https://landingfoliocom.imgix.net/store/collection/saasui/images/cta/7/waverio.svg"
              alt="Waverio"
            />
            <img
              className="object-contain h-8 max-w-full sm:h-10 w-44"
              src="https://landingfoliocom.imgix.net/store/collection/saasui/images/cta/7/logoipsum.svg"
              alt="Logoipsum"
            />
            <img
              className="object-contain h-8 max-w-full sm:h-10 w-44"
              src="https://landingfoliocom.imgix.net/store/collection/saasui/images/cta/7/alterbone.svg"
              alt="Alterbone"
            />
            <img
              className="object-contain h-8 max-w-full sm:h-10 w-44"
              src="https://landingfoliocom.imgix.net/store/collection/saasui/images/cta/7/carbonia.svg"
              alt="Carbonia"
            />
            <img
              className="object-contain h-8 max-w-full sm:h-10 w-44"
              src="https://landingfoliocom.imgix.net/store/collection/saasui/images/cta/7/tinygone.svg"
              alt="Tinygone"
            />
            <img
              className="object-contain h-8 max-w-full sm:h-8 w-44"
              src="https://landingfoliocom.imgix.net/store/collection/saasui/images/cta/7/preso.svg"
              alt="Preso"
            />
            <img
              className="object-contain h-8 max-w-full sm:h-10 w-44"
              src="https://landingfoliocom.imgix.net/store/collection/saasui/images/cta/7/ridoria.svg"
              alt="Ridoria"
            />
            <img
              className="object-contain h-8 max-w-full sm:h-10 w-44"
              src="https://landingfoliocom.imgix.net/store/collection/saasui/images/cta/7/incanto.svg"
              alt="Incanto"
            />
          </div>
        </div> */}
      </div>
    </section>
  );
};

// ========================
// HighlightFeatures Component (Updated)
// ========================
const HighlightFeatures = () => {
  const features = [
    {
      title: "Secure & Compliant Transactions",
      description:
        "Protect your campaign data with robust security protocols and ensure GDPR compliance for all transactions.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-10 h-10 text-blue-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 11c0-1.657 1.343-3 3-3h1V4a1 1 0 10-2 0v5h-1a1 1 0 00-1 1v4a1 1 0 001 1h3m0 0v2a1 1 0 001 1h2a1 1 0 001-1v-2m-5 2h5"
          />
        </svg>
      ),
    },
    {
      title: "Lightning Fast Performance",
      description:
        "Experience unmatched speed and reliability for managing all your personalized outreach campaigns seamlessly.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-10 h-10 text-orange-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 10V3L4 14h7v7l9-11h-7z"
          />
        </svg>
      ),
    },
    {
      title: "Real-Time Analytics",
      description:
        "Gain immediate insights into campaign performance with detailed analytics to continually optimize your personalized outreach.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-10 h-10 text-cyan-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 10h4v10H3V10zm6-4h4v14h-4V6zm6 6h4v8h-4v-8z"
          />
        </svg>
      ),
    },
    {
      title: "Intuitive Dashboard",
      description:
        "Manage your personalized marketing campaigns with a user-friendly interface designed for efficiency and ease.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-10 h-10 text-purple-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 10h16M4 14h16M4 18h16"
          />
        </svg>
      ),
    },
    {
      title: "LinkedIn Outreach",
      description:
        "Engage directly with prospects on LinkedIn through seamless integration to build meaningful connections.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-10 h-10 text-blue-800"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M20.447 20.452h-3.554v-5.569c0-1.327-.024-3.037-1.851-3.037-1.853 0-2.137 1.445-2.137 2.939v5.667H9.354V9h3.414v1.561h.049c.476-.9 1.637-1.851 3.369-1.851 3.602 0 4.268 2.368 4.268 5.455v6.287zM5.337 7.433c-1.144 0-2.071-.928-2.071-2.07 0-1.143.927-2.07 2.071-2.07 1.143 0 2.07.927 2.07 2.07 0 1.142-.927 2.07-2.07 2.07zm1.777 13.019H3.56V9h3.554v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.225.792 24 1.771 24h20.451C23.205 24 24 23.225 24 22.271V1.729C24 .774 23.205 0 22.225 0z" />
        </svg>
      ),
    },
    {
      title: "Omni-Channel Marketing",
      description:
        "Deliver personalized messages across multiple platforms including email, social media, and SMS with ease.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-10 h-10 text-red-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 7h18M3 12h18m-9 5h9"
          />
        </svg>
      ),
    },
    {
      title: "A/B Testing",
      description:
        "Test and optimize your messages by comparing different variants to maximize engagement.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-10 h-10 text-yellow-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M11 12h9m-9 4h9m-9-8h9M3 6h.01M3 12h.01M3 18h.01"
          />
        </svg>
      ),
    },
    {
      title: "Customizable Draft Templates",
      description:
        "Access a library of pre-built templates that can be easily tailored to align with your brand voice.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-10 h-10 text-indigo-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5h6m-3-3v3m-4 4h8m-8 4h8m-8 4h8"
          />
        </svg>
      ),
    },
  ];

  return (
    <section className="py-10 bg-white sm:py-16 lg:py-24">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 md:grid-cols-4">
          {features.map((feature, index) => (
            <div key={index} className="text-center">
              <div className="flex items-center justify-center mx-auto mb-4">
                {feature.icon}
              </div>
              <h3 className="mt-4 text-lg font-semibold text-black">{feature.title}</h3>
              <p className="mt-2 text-base text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// ========================
// Pricing Component
// ========================
const Pricing = () => {
  return (
    <section className="py-12 bg-white sm:py-16 lg:py-20">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl xl:text-5xl font-pj">
            Choose Your Credits Package
          </h2>
          <p className="max-w-xl mx-auto mt-6 text-base font-normal text-gray-600 font-pj">
            Select the package that suits your needs. Enjoy flexible monthly pricing with an option for pay‑as‑you‑go.
          </p>
        </div>

        {/* Mobile Pricing View */}
        <div className="block mt-12 sm:hidden">
          <div className="grid grid-cols-2 text-center divide-x divide-gray-200">
            <div className="px-2 py-4">
              <h2 className="font-bold text-gray-900 font-pj text-lg">300 Credits</h2>
              <a
                href="#"
                className="inline-flex items-center justify-center px-2 py-2 mt-4 text-sm font-bold text-white transition-all duration-200 bg-gray-900 border border-transparent rounded hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
                role="button"
              >
                Get for $28/mo
              </a>
            </div>
            <div className="px-2 py-4">
              <h2 className="font-bold text-gray-900 font-pj text-lg">800 Credits</h2>
              <a
                href="#"
                className="inline-flex items-center justify-center px-2 py-2 mt-4 text-sm font-bold text-white transition-all duration-200 bg-gray-900 border border-transparent rounded hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
                role="button"
              >
                Get for $55/mo
              </a>
            </div>
          </div>
          <p className="mt-4 text-center text-sm text-gray-600">
            More options available on desktop.
          </p>
        </div>

        {/* Desktop Pricing Table */}
        <div className="hidden mt-16 sm:block">
          <table className="w-full max-w-5xl mx-auto lg:table-fixed font-pj">
            <thead>
              <tr>
                <th className="py-8 pr-4" colSpan="1"></th>
                <th className="px-4 py-8 text-center">
                  <h2 className="font-bold text-gray-900 font-pj text-lg">300 Credits</h2>
                </th>
                <th className="px-4 py-8 text-center">
                  <h2 className="font-bold text-gray-900 font-pj text-lg">800 Credits</h2>
                </th>
                <th className="px-4 py-8 text-center">
                  <h2 className="font-bold text-gray-900 font-pj text-lg">1400 Credits</h2>
                </th>
                <th className="px-4 py-8 text-center">
                  <h2 className="font-bold text-gray-900 font-pj text-lg">3000 Credits</h2>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="divide-x divide-gray-200">
                <td className="py-4 pr-4 font-medium border-b border-gray-200">Monthly Price</td>
                <td className="px-4 py-4 text-center border-b border-gray-200">$28</td>
                <td className="px-4 py-4 text-center border-b border-gray-200">$55</td>
                <td className="px-4 py-4 text-center border-b border-gray-200">$75</td>
                <td className="px-4 py-4 text-center border-b border-gray-200">$140</td>
              </tr>
              <tr className="divide-x divide-gray-200">
                <td className="py-4 pr-4 font-medium border-b border-gray-200">Pay As You Go Price</td>
                <td className="px-4 py-4 text-center border-b border-gray-200">$30</td>
                <td className="px-4 py-4 text-center border-b border-gray-200">$60</td>
                <td className="px-4 py-4 text-center border-b border-gray-200">$90</td>
                <td className="px-4 py-4 text-center border-b border-gray-200">$150</td>
              </tr>
              <tr className="divide-x divide-gray-200">
                <td className="py-4 pr-4 font-medium">Credits Included</td>
                <td className="px-4 py-4 text-center">300</td>
                <td className="px-4 py-4 text-center">800</td>
                <td className="px-4 py-4 text-center">1400</td>
                <td className="px-4 py-4 text-center">3000</td>
              </tr>
              <tr className="divide-x divide-gray-200">
                <td className="px-4 py-8"></td>
                <td className="px-4 py-8 text-center"></td>
                <td className="px-4 py-8 text-center"></td>
                <td className="px-4 py-8 text-center"></td>
                <td className="px-4 py-8 text-center"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

// ========================
// FAQ (full updated set)
// ========================
const faqs = [
  {
    question: "What is PreciseDraft.ai?",
    answer:
      "A B2B personalization platform. We turn live buying signals into proof-backed, 1:1 messages written in your voice—and run them as governed, omnichannel campaigns (LinkedIn messaging, Apollo exports, CRM/CDP sync)."
  },
  {
    question: "What are the advantages of personalized marketing versus conventional outreach?",
    answer:
      "Low-volume, high-intent, and auditable. Instead of templated blasts, we send only when a material signal exists, tailor the message to each role, and multi-thread the buying committee—driving higher reply quality and cleaner pipeline."
  },
  {
    question: "Do you support automated campaigns?",
    answer:
      "Yes. Full automations with stage specific templates, timing, and rules across channels. For LinkedIn, you can generate up to 20 connection messages at a time in a bulk composer—each personalized with tokens/receipts—and schedule sends with pacing that respects platform limits. You can import lead lists exported from Apollo (CSV) to personalize and send messages here. Email is supported via Apollo exports, and CRM/CDP integrations (e.g., HubSpot, Salesforce, Segment) keep statuses in sync."
  },
  {
    question: "Can you enrich leads if I don’t have valid emails?",
    answer:
      "Yes. We can run B2B enrichment to discover updated work emails and phone numbers for the leads you provide. Results aren’t always guaranteed but we try to return validated emails from multiple searches. Catch-all domains are treated as invalid and excluded from campaigns. We verify via MX/DNS/SMTP and partner checks and return statuses (Verified, Risky, Catch-all, Invalid). By default, only Verified records move forward and compliance rules are applied."
  },
  {
    question: "What metrics do I get?",
    answer:
      "Delivery & engagement: deliveries, bounces, spam complaints, opens, clicks, replies. Quality: Positive Interest Rate (PIR), Threading Success (% accounts with ≥2 roles engaged), Time-to-Positive/POC. Operations: domain health score (DHS), warmup/ramp status, suppression events."
  },
  {
    question: "What are your Quality Gates?",
    answer:
      "Each message must include a verified receipt, pass a Personalization Quality Score (PQS) threshold, meet role-fit and Voicebook rules, and clear uniqueness/blocked-phrase checks."
  },
  {
    question: "How do you handle compliance and deliverability?",
    answer:
      "Built-in CAN-SPAM/CASL/GDPR controls (identification, unsubscribe/opt-out syncing, list provenance). We manage DKIM/SPF/DMARC checks, domain warmup and pacing, frequency caps, suppression, and reputation monitoring. While no platform can guarantee inbox placement, our spam-risk filters and DHS guardrails (auto-pause below thresholds) materially improve deliverability."
  },
  {
    question: "Do you filter spam and protect sender reputation?",
    answer:
      "Yes. We run spam-risk heuristics, monitor complaint/bounce rates, and enforce DHS guardrails. Anomalies trigger throttling or auto-pauses, and abusers are removed to protect the ecosystem and all customers’ reputation."
  },
  {
    question: "Is my data secure with PreciseDraft.ai?",
    answer:
      "Yes. Encryption in transit and at rest, role-based access, audit trails, least-privilege services, and clear retention/deletion controls. We minimize PII and support regional data choices where applicable."
  }
];


const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="container mx-auto px-4 py-10">
      <h1 className="text-4xl font-bold mb-8 text-center text-gray-800">Frequently Asked Questions</h1>
      <div className="max-w-3xl mx-auto">
        {faqs.map((faq, index) => (
          <div key={index} className="mb-4">
            <button
              className="w-full text-left bg-gray-100 px-6 py-4 rounded-md flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-blue-500"
              onClick={() => toggleFAQ(index)}
            >
              <span className="text-lg font-medium text-gray-800">{faq.question}</span>
              <span className="ml-4 text-xl font-bold text-gray-600">{activeIndex === index ? "-" : "+"}</span>
            </button>
            {activeIndex === index && (
              <div className="mt-2 bg-white px-6 py-4 border border-t-0 border-gray-200 rounded-b-md">
                <p className="text-gray-700">{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

// ========================
// Reviews Component (Updated)
// ========================
const Reviews = () => {
  // Updated totals for consistency
  const totalReviews = 3498;
  const starBreakdown = {
    5: 2000,
    4: 800,
    3: 300,
    2: 150,
    1: 248,
  };

  // Percentages for progress bars (rounded estimates)
  const progressPercentages = {
    5: "57%",
    4: "23%",
    3: "9%",
    2: "4%",
    1: "7%",
  };

  // Review data for individual user reviews updated with PreciseDraft-specific comment and new dates.
  const reviewsData = [
    {
      name: "Bessie Cooper",
      date: "March 14, 2025",
      rating: 5,
      title: "Super fast, easy to use",
      review:
        "PreciseDraft is incredibly fast and efficient. I quickly built a highly effective personalized email campaign using its advanced customization options. The real-time analytics and excellent customer support have truly set this platform apart.",
      verified: true,
    },
    {
      name: "John Smith",
      date: "April 5, 2025",
      rating: 5,
      title: "Outstanding Personalized Outreach!",
      review:
        "PreciseDraft has revolutionized our marketing outreach. The personalized emails have boosted our response rates and engagement significantly.",
      verified: true,
    },
    {
      name: "Emily Rodriguez",
      date: "May 10, 2024",
      rating: 4,
      title: "Great for targeted campaigns",
      review:
        "The tailored messaging allowed us to directly connect with our prospects. Our click-through rates have improved dramatically after using these customized templates.",
      verified: true,
    },
    {
      name: "Michael Parker",
      date: "June 21, 2024",
      rating: 4,
      title: "Engaging and Efficient",
      review:
        "I love the balance between automation and personalization offered by PreciseDraft. Our campaigns have a more human touch now, saving us valuable time.",
      verified: true,
    },
    {
      name: "Sofia Ramirez",
      date: "July 30, 2024",
      rating: 5,
      title: "A must-have for modern marketers",
      review:
        "Using PreciseDraft's innovative email templates gave our outreach campaigns a huge boost. The platform is intuitive and very effective for personalized marketing.",
      verified: false,
    },
  ];

  // Helper function to render star icons based on review rating
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <svg
        key={i}
        className={`w-5 h-5 ${i < rating ? "text-amber-500" : "text-gray-300"}`}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ));
  };

  return (
    <section className="py-12 bg-white sm:py-16 lg:py-20">
      <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
        <div className="max-w-3xl mx-auto">
          {/* Overall Ratings Summary */}
          <div className="grid grid-cols-1 gap-y-8 sm:grid-cols-2 gap-x-16">
            <div>
              <h3 className="text-xl font-bold text-gray-900">Customer reviews &amp; ratings</h3>
              <div className="flex items-center mt-6">
                <div className="flex items-center space-x-px">
                  {renderStars(4)}
                  <svg
                    className="w-5 h-5 text-amber-500"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                </div>
                {/* <span className="ml-3 text-sm font-medium text-gray-600">
                  (4.2/5 from {totalReviews.toLocaleString()} reviews)
                </span> */}
              </div>
              <p className="text-sm font-medium text-gray-600 mt-2.5">
                Based on {totalReviews.toLocaleString()} reviews
              </p>
            </div>
            <div>
              <ul className="space-y-2.5">
                {Object.keys(starBreakdown).map((star) => (
                  <li key={star} className="grid items-center grid-cols-5 gap-x-4">
                    <span className="text-sm font-medium text-gray-600 whitespace-nowrap">
                      {star} stars
                    </span>
                    <div className="col-span-3 relative w-full bg-gray-200 rounded-full h-1.5">
                      <div
                        className="absolute inset-y-0 left-0 bg-gray-900 rounded-full"
                        style={{ width: progressPercentages[star] }}
                      ></div>
                    </div>
                    <span className="text-sm font-medium text-gray-600 whitespace-nowrap">
                      {starBreakdown[star].toLocaleString()}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <hr className="mt-10 border-gray-200" />

          {/* User Reviews */}
          <div className="flow-root mt-10">
            <ul className="divide-y divide-gray-200">
              {reviewsData.map((review, index) => (
                <li
                  key={index}
                  className="py-8 grid grid-cols-1 gap-y-8 md:grid-cols-7 gap-x-8"
                >
                  <div className="md:col-span-2">
                    <div className="flex items-center space-x-px">
                      {renderStars(review.rating)}
                    </div>
                    <div className="flex items-start mt-5 md:flex-col">
                      <div className="flex-shrink-0">
                        <p className="text-sm font-bold text-gray-900">{review.name}</p>
                        <p className="mt-1 text-sm font-normal text-gray-500">{review.date}</p>
                      </div>
                      {review.verified && (
                        <div className="flex items-center ml-4 text-sm font-medium text-gray-600 md:ml-0 md:mt-4">
                          <svg
                            className="h-5 w-5 text-green-500 flex-shrink-0 mr-1.5"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"
                            />
                          </svg>
                          <span>Verified</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="md:col-span-5">
                    <p className="text-base font-bold text-gray-900">{review.title}</p>
                    <blockquote className="mt-4">
                      <p className="text-sm font-normal leading-6 text-gray-900">{review.review}</p>
                    </blockquote>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

// ========================
// Animated Email Preview Component
// ========================
const AnimatedEmailPreview = () => {
  // Array of personalized email examples (8 examples in total)
  const emailExamples = [
    `Hi John,

I noticed you attended our recent webinar on AI innovations. Because of your interest, I’d love to share an exclusive offer tailored just for your industry!

Best regards,
The PreciseDraft Team`,
    `Hello Sarah,

Your recent inquiry about our solutions caught our attention. We have a special discount available exclusively for our valued prospects. Let’s schedule a quick call to discuss details.

Cheers,
Your PreciseDraft Team`,
    `Dear Alex,

Thank you for your insightful feedback on our last update. We’re excited to offer you a sneak peek at our upcoming features. I look forward to exploring this further with you.

Warm regards,
The PreciseDraft Team`,
    `Hi Emily,

I saw that you’ve been exploring our product features. As a token of our appreciation, I’d like to offer you a personalized demo with exclusive benefits. Let’s connect soon!

Best,
PreciseDraft Team`,
    `Hi Michael,

I came across your recent article on digital marketing trends and was impressed by your insights. At PreciseDraft, we believe personalized outreach can amplify your strategy. Would you be open to discussing a tailored offer?

Regards,
The PreciseDraft Team`,
    `Dear Lisa,

I hope you're having a productive week. Our analysis shows opportunities in your current outreach efforts, and we’d love to provide a personalized consultation to boost your engagement. Let’s connect!

Sincerely,
PreciseDraft Team`,
    `Hello Robert,

Noticing your company’s expansion, we thought you might benefit from our customized email solutions that drive higher engagement. We’re offering a free audit of your current campaigns. Interested?

Best regards,
The PreciseDraft Team`,
    `Hi Vanessa,

Thank you for your commitment to excellence in customer service. We specialize in creating personalized messages that convert. I’d love to discuss how our tailored outreach can help elevate your business.

Warmly,
PreciseDraft Team`
  ];

  // Typewriter effect state variables
  const [currentEmailIndex, setCurrentEmailIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState("");
  const [typing, setTyping] = useState(true);

  // Speed/delay settings (in milliseconds)
  const TYPING_SPEED = 50;
  const PAUSE_AFTER_TYPING = 2000;
  const ERASING_SPEED = 30;

  useEffect(() => {
    let timerId;
    const currentEmail = emailExamples[currentEmailIndex];

    if (typing) {
      if (displayedText.length < currentEmail.length) {
        timerId = setTimeout(() => {
          setDisplayedText(currentEmail.slice(0, displayedText.length + 1));
        }, TYPING_SPEED);
      } else {
        // Pause after full text is typed
        timerId = setTimeout(() => {
          setTyping(false);
        }, PAUSE_AFTER_TYPING);
      }
    } else {
      // Erasing effect
      if (displayedText.length > 0) {
        timerId = setTimeout(() => {
          setDisplayedText(currentEmail.slice(0, displayedText.length - 1));
        }, ERASING_SPEED);
      } else {
        // Move to the next email and restart typing
        setCurrentEmailIndex((prevIndex) => (prevIndex + 1) % emailExamples.length);
        setTyping(true);
      }
    }

    return () => clearTimeout(timerId);
  }, [displayedText, typing, currentEmailIndex, emailExamples]);

  return (
    <div className="bg-white border border-[#003F5C] rounded-lg shadow-lg p-6 w-full">
      <h3 className="text-lg font-bold text-[#003F5C] mb-2">Personalized Email Preview</h3>
      <p className="text-[#003F5C] whitespace-pre-wrap font-mono">{displayedText}</p>
    </div>
  );
};

// ========================
// Main Home Component
// ========================
const Home = () => {
  // Environment variables for authentication URL (configure in your .env)
  const {
    REACT_APP_COGNITO_DOMAIN,
    REACT_APP_COGNITO_CLIENT_ID,
    REACT_APP_COGNITO_REDIRECT_URI,
  } = process.env;

  // Construct the login URL using template literals
  const loginUrl = `${REACT_APP_COGNITO_DOMAIN}/login?response_type=code&client_id=${REACT_APP_COGNITO_CLIENT_ID}&redirect_uri=${encodeURIComponent(
    REACT_APP_COGNITO_REDIRECT_URI
  )}&scope=openid+email+phone`;

  const [cookieAccepted, setCookieAccepted] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("gdprCookieAccepted");
    if (accepted === "true") {
      setCookieAccepted(true);
    }
  }, []);

  const handleAcceptCookies = () => {
    localStorage.setItem("gdprCookieAccepted", "true");
    setCookieAccepted(true);
  };

  return (
    <div className="bg-white text-gray-800 font-sans">
      {/* HEADER */}
      {/* [Header code omitted for brevity] */}

      {/* HERO SECTION */}
<section className="relative overflow-hidden" style={{ backgroundColor: "#FFF8F0" }}>
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 sm:pt-16 pb-16 sm:pb-24">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
      <div>
        <h1
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight text-[#003F5C]"
        >
          <span className="block md:inline">Precision Messaging</span>{" "}
          <span className="block md:inline">for Founders</span>
        </h1>

        <p className="mt-3 sm:mt-4 text-lg sm:text-xl md:text-2xl font-semibold leading-snug text-[#003F5C]">
          Every Draft Designed to Engage
        </p>

        <p className="mt-4 text-base sm:text-lg text-gray-700 max-w-xl">
  We transform insights into  personalized messages written in your voice.
  Compatible with <strong>LinkedIn messaging, Apollo exports, and CRM integrations</strong>.
</p>

        <div className="mt-6 sm:mt-8 flex flex-wrap gap-3">
          <a
            href={loginUrl}
            className="inline-flex items-center px-6 py-3 text-base font-semibold text-white rounded-md hover:opacity-90"
            style={{ backgroundColor: "#FF6F61" }}
          >
            Get Started
          </a>
        </div>
      </div>

      <div className="flex justify-center md:justify-end">
        <AnimatedEmailPreview />
      </div>
    </div>
  </div>
</section>


      {/* CALL TO ACTION */}
      <CallToAction />

      {/* HIGHLIGHT FEATURES SECTION */}
      <HighlightFeatures />

      {/* PRICING SECTION */}
      <Pricing />

      {/* FAQ SECTION */}
      <FAQ />

      {/* REVIEWS SECTION */}
      <Reviews />

      {/* FOOTER */}
      <footer className="py-10" style={{ backgroundColor: "#003F5C" }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:col-span-3 lg:grid-cols-6 gap-y-16 gap-x-12">
            <div className="col-span-2 md:col-span-3 lg:col-span-2 lg:pr-8">
              <a href="/" className="text-xl font-bold tracking-tight text-white">
                PreciseDraft
              </a>
              <p className="text-base leading-relaxed text-gray-300 mt-4">
                The fastest, easiest way to craft personalized sales emails. Let us handle the outreach while you grow your business.
              </p>
            </div>
            {/* <div>
              <p className="text-sm font-semibold tracking-widest text-gray-400 uppercase">
                Company
              </p>
              <ul className="mt-6 space-y-4">
                <li>
                  <a href="#" className="flex text-base text-gray-200 transition-all duration-200 hover:text-white">
                    About
                  </a>
                </li>
                <li>
                  <a href="#" className="flex text-base text-gray-200 transition-all duration-200 hover:text-white">
                    Works
                  </a>
                </li>
                <li>
                  <a href="#" className="flex text-base text-gray-200 transition-all duration-200 hover:text-white">
                    Career
                  </a>
                </li>
              </ul>
            </div> */}
            <div>
              {/* <p className="text-sm font-semibold tracking-widest text-gray-400 uppercase">
                Help
              </p> */}
              <ul className="mt-6 space-y-4">
                {/* <li>
                  <a href="#" className="flex text-base text-gray-200 transition-all duration-200 hover:text-white">
                    Customer Support
                  </a>
                </li>
                <li>
                  <a href="#" className="flex text-base text-gray-200 transition-all duration-200 hover:text-white">
                    Delivery Details
                  </a>
                </li> */}
                <li>
                  <a href="/terms" className="flex text-base text-gray-200 transition-all duration-200 hover:text-white">
                    Terms &amp; Conditions
                  </a>
                </li>
                <li>
                  <a href="privacy" className="flex text-base text-gray-200 transition-all duration-200 hover:text-white">
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-span-2 md:col-span-1 lg:col-span-2 lg:pl-8">
              <p className="text-sm font-semibold tracking-widest text-gray-400 uppercase">
                Subscribe to newsletter
              </p>
              <form action="#" method="POST" className="mt-6">
                <div>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Enter your email"
                    className="block w-full p-3 text-gray-900 placeholder-gray-500 transition duration-200 bg-white border border-gray-300 rounded-md focus:outline-none focus:border-[#FF6F61] caret-[#FF6F61]"
                  />
                </div>
                <button
                  type="submit"
                  className="inline-flex items-center justify-center px-6 py-3 mt-3 font-semibold text-white rounded-md hover:opacity-90"
                  style={{ backgroundColor: "#FF6F61" }}
                >
                  Subscribe
                </button>
              </form>
            </div>
          </div>
          <hr className="mt-16 mb-10 border-gray-700" />
          <p className="text-sm text-center text-gray-400">
            © {new Date().getFullYear()}, All Rights Reserved by PreciseDraft
          </p>
        </div>
      </footer>

      {/* GDPR COOKIE NOTICE */}
      {!cookieAccepted && (
        <div className="fixed bottom-0 w-full bg-gray-900 text-white p-4 z-50 flex items-center justify-center">
          <p className="text-sm mr-4">
            We use cookies to improve your experience. By using our site, you consent to cookies.
          </p>
          <button
            onClick={handleAcceptCookies}
            className="px-4 py-2 text-sm font-semibold rounded hover:opacity-80"
            style={{ backgroundColor: "#FF6F61" }}
          >
            Accept
          </button>
        </div>
      )}
    </div>
  );
};

export default Home;
